import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { NgToastTranslocoService } from 'src/app/common/services/ng-toast-transloco/ng-toast-transloco.service';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { LoaderService } from 'src/app/common/services/loader/loader.service';

@Component({
  selector: 'ds-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {

  @Output() goToSignin = new EventEmitter();
  @Output() passwordReset = new EventEmitter<{ email: string; password: string }>();

  @Input() emailAddress: string = '';

  resetPasswordForm: FormGroup;
  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private toast: NgToastTranslocoService,
    private cdr: ChangeDetectorRef,
    private loaderService: LoaderService
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.initForm();
    // if (this.emailAddress) {
    //   this.resetPasswordForm.patchValue({ email: this.emailAddress });
    // }
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  initForm() {
    this.resetPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      password: ['', [Validators.required, this.validatePassword()]],
      confirmPassword: ['', [Validators.required]]
    }, { validators: this.passwordMatchValidator() });
  }

  get email() {
    return this.resetPasswordForm.get('email');
  }

  get password() {
    return this.resetPasswordForm.get('password');
  }

  get confirmPassword() {
    return this.resetPasswordForm.get('confirmPassword');
  }

  validatePassword(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const password = control.value;

      if (!password) {
        return null;
      }

      const hasUpperCase = /[A-Z]/.test(password);
      const hasLowerCase = /[a-z]/.test(password);
      const hasNumeric = /[0-9]/.test(password);
      const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
      const isValidLength = password.length >= 8;

      const passwordValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar && isValidLength;

      return !passwordValid ? { passwordStrength: true } : null;
    };
  }

  passwordMatchValidator(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const password = group.get('password')?.value;
      const confirmPassword = group.get('confirmPassword')?.value;

      if (password && confirmPassword && password !== confirmPassword) {
        return { mismatch: true };
      }
      return null;
    };
  }

  async submit() {
    if (!this.resetPasswordForm.valid) {
      this.resetPasswordForm.markAllAsTouched();
      this.cdr.detectChanges();
      return;
    }

    const accountNumber = this.emailAddress;
    const email = this.email?.value;
    const password = this.password?.value;

    if (email && password) {
      this.loaderService.setLoaderStateActive(true, 'cognito_service_url');
      this.authService.sendOtp(email, password, accountNumber).subscribe(
        (response) => {
          this.loaderService.setLoaderStateActive(false, 'cognito_service_url');
          this.toast.toastSuccess('MODULES.LOGIN.LOGIN_OTP');
          this.passwordReset.emit({ email, password });
        },
        (error) => {
          this.loaderService.setLoaderStateActive(false, 'cognito_service_url');
          this.toast.toastErrorMsg('Failed to send OTP:' + error);
        }
      );
    }
  }

  goBack() {
    this.goToSignin.emit();
  }
}
